export default __webpack_public_path__ + "fonts/close-btn-blue.svg";